export default __webpack_public_path__ + "static/8334-ca7fc1a6cc96cfafa04d1544cab94a23.jpg";